import { createLazyComponent } from '@luna/utils-ui';

export const LazyDevToolsEventHistory = createLazyComponent(() =>
    import('./DevToolsEventHistory').then(({ DevToolsEventHistory }) => DevToolsEventHistory),
);
